import type { CompanyContent } from "../content/company";
import { Editable } from "../edit";
import { CtaBandSection, PageHero, SectionHead } from "./common";

export function CompanySections({ content }: { content: CompanyContent }) {
  const c = content;
  return (
    <>
      <PageHero path="hero" eyebrow={c.hero.eyebrow} heading={c.hero.heading} lede={c.hero.lede} />

      <section className="section" style={{ paddingTop: 0 }} id="consortium">
        <div className="wrap">
          <div className="partners">
            {c.consortium.partners.map((p, i) => (
              <article className="partner" key={i}>
                <Editable as="span" className="role" path={`consortium.partners.${i}.role`} value={p.role} />
                <Editable as="h3" path={`consortium.partners.${i}.name`} value={p.name} />
                <Editable as="p" path={`consortium.partners.${i}.description`} value={p.description} singleLine={false} />
                <ul>
                  {p.bullets.map((b, j) => (
                    <Editable as="li" key={j} path={`consortium.partners.${i}.bullets.${j}`} value={b} />
                  ))}
                </ul>
                <p>
                  <a className="text-link" href={p.linkHref} target="_blank" rel="noopener">
                    <Editable as="span" path={`consortium.partners.${i}.linkLabel`} value={p.linkLabel} />{" "}
                    <span className="arrow" aria-hidden="true">
                      ↗
                    </span>
                  </a>
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ paddingTop: 0 }}>
        <div className="wrap split" style={{ alignItems: "start" }}>
          <div className="copy">
            <Editable as="p" className="eyebrow" path="independence.eyebrow" value={c.independence.eyebrow} />
            <Editable as="h2" path="independence.heading" value={c.independence.heading} />
            <Editable as="p" className="lede" path="independence.lede" value={c.independence.lede} singleLine={false} />
          </div>
          <ul className="checks" style={{ paddingTop: 8 }}>
            {c.independence.checks.map((ck, i) => (
              <li key={i}>
                <span>
                  <Editable as="b" path={`independence.checks.${i}.boldLead`} value={ck.boldLead} />{" "}
                  <Editable as="span" path={`independence.checks.${i}.text`} value={ck.text} />
                </span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <hr className="divider" />

      <section className="section">
        <div className="wrap">
          <SectionHead
            path="whereWeOperate"
            eyebrow={c.whereWeOperate.eyebrow}
            heading={c.whereWeOperate.heading}
            lede={c.whereWeOperate.lede}
          />
          <div className="regions">
            {c.whereWeOperate.regions.map((r, i) => (
              <div key={i}>
                <Editable as="h4" path={`whereWeOperate.regions.${i}.name`} value={r.name} />
                <Editable as="p" path={`whereWeOperate.regions.${i}.places`} value={r.places} />
              </div>
            ))}
          </div>
        </div>
      </section>

      <hr className="divider" />

      <CtaBandSection path="ctaBand" content={c.ctaBand} />
    </>
  );
}
